import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { updateGroupProperties } from '../../../services/groupsService'
import { GroupContext } from '../GroupContextProvider'

export default function TombstoneGroupDialogOverlay({ ...overlay }) {
  const { t } = useTranslation()
  const { currentGroupData, fetchCurrentGroupData } = useContext(GroupContext)
  const { error } = useNotifications()

  const confirmBtnOnClick = async () => {
    try {
      const groupUpdateProperties = {
        name: currentGroupData.name,
        description: currentGroupData.description,
        tombstoned: true,
        joinPolicy: currentGroupData.joinPolicy,
        sizeLimit: currentGroupData.sizeLimit.toString(),
        codeOfConduct: currentGroupData.codeOfConduct,
        treeInitialized: currentGroupData.treeInitialized,
        types: currentGroupData.types,
        organizationId: currentGroupData.organizationId,
        private: currentGroupData.private,
      }
      overlay.close()
      await updateGroupProperties(currentGroupData.id, groupUpdateProperties)
      fetchCurrentGroupData()
    } catch (err) {
      error(
        t('group.errors.tombstoningDroup', {
          defaultValue: `Error tombstoning group: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  return (
    <DialogOverlay
      {...overlay}
      title={t('group.summary.dialogOverlay.tombstone.heading', 'Tombstone Group')}
      subtitle={currentGroupData.id}
      size="sm"
    >
      <Paragraph size="sm">
        {t('group.summary.dialogOverlay.tombstone.body', 'Are you sure you want to tombstone this group?')}
      </Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
